import {history} from '../../../helpers/history';

import {ToolsBarItem} from './item/ToolsBarItem'

import './ToolsBar.scss'
import React, {useState} from 'react'
import {useEffect} from 'react';
import {useTypedSelector} from "../../../hooks/useTypeSelector";
import {SelectPageForTabsDto, UserDto} from "../../../dtos";
import {useDispatch} from "react-redux";
import {savePromosItemsExcelFileInDBForLoadItemsImages} from "../../../store/actionCreators/promotionsItemsCreators";
import {dispatchEventDataType, EVENT_DATA_TYPE_OPEN_FLYER_INFO_POPUP} from "../../../globals/EventDispatcher";

type Props = {
    isDisabledTabs: boolean
}

export const ToolsBar: React.FC<Props> = (props) => {
    const dispatch = useDispatch();
    let userDtoStr = localStorage.getItem('userDto');
    let userDto: UserDto = JSON.parse(userDtoStr!);
    const isAccountTier1 = userDto?.accountTier === 1;
    let flyerDetailsState = useTypedSelector((state) => state.flyerDetails);
    let selectedPageState = useTypedSelector<SelectPageForTabsDto>((state) => state.selectPageForTabs);
    let changedStateForFlyer = useTypedSelector((state) => state.changedStateForFlyer);
    let flippingFlyerState = useTypedSelector((state) => state.flippingFlyer);
    const [isDisabledRightTabBtn, setDisabledRightTabBtn] = useState<boolean>(false);

    const [selectedIndex, setSelectedIndex] = useState(0)

    const onItemClick = (index: number) => {
        dispatchEventDataType<string | undefined>(EVENT_DATA_TYPE_OPEN_FLYER_INFO_POPUP, {
            isOpen: false,
            isChangedData: changedStateForFlyer.isChangedFlyerData
        });
        if (!changedStateForFlyer.isChangedFlyerData) {
            if (index === 0) {
                if (userDtoStr !== null) {
                    history.push(`/flyersCatalog`);
                    setSelectedIndex(index);
                    //reset promotion and items screen excel file
                    dispatch(savePromosItemsExcelFileInDBForLoadItemsImages({}));
                }
            } else if (index === 1 && !props.isDisabledTabs) {
                // dispatch(getFlippingFlyer(flyerDetailsState.flyRecId));
                history.push(`/flyersCatalog/${flyerDetailsState.flyRecId}/pages`);
                setSelectedIndex(index);
            } else if (index === 2 && !props.isDisabledTabs) {
                history.push(`/flyersCatalog/${flyerDetailsState.flyRecId}/frames`);
                // history.push(`/flyersCatalog/flyerId/1/spots`);
                setSelectedIndex(index);
            } else if (index === 3 && !props.isDisabledTabs) {
                history.push(`/flyersCatalog/${flyerDetailsState.flyRecId}/promos`);
                // history.push(`/flyersCatalog/flyerId/1/promos`);
                setSelectedIndex(index);
            }
        }
        // else if(index === 4 && !props.isDisabledTabs){
        //     history.push(`/flyersCatalog/flyerId/${flyerDetailsState.flyRecId}/promoitems`);
        //     // history.push(`/flyersCatalog/flyerId/1/promoitems`);
        //     setSelectedIndex(index);
        // }
    }

    useEffect(() => {
        onItemClick(selectedPageState.selectedTabNum!);
    }, [selectedPageState])

    useEffect(() => {
        // if (location.pathname.indexOf('/flyersCatalog') === -1) {
        //     onItemClick(0);
        // }
        //onItemClick(2)
    }, [])


    useEffect(() => {
        if (flippingFlyerState.type !== 'GET_FLIPPING_FLYER_ERROR') {
            setDisabledRightTabBtn(flippingFlyerState.loading);
        }
    }, [flippingFlyerState.type]);

    return (
        <div className="tools_bar_container">
            <ToolsBarItem
                index={0}
                title="Flyers"
                onClick={onItemClick}
                selected={selectedIndex === 0}
                isAboveTheSelected={0 + 1 === selectedIndex}
                isBelowTheSelected={0 - 1 === selectedIndex}
            />
            <ToolsBarItem
                index={1}
                title="Pages"
                onClick={onItemClick}
                selected={selectedIndex === 1}
                isAboveTheSelected={1 + 1 === selectedIndex}
                isBelowTheSelected={1 - 1 === selectedIndex}
                isDisabledTab={props.isDisabledTabs || isDisabledRightTabBtn || isAccountTier1}
                titleForBtn={isAccountTier1 ? "Upgrade your account" : ""}
            />
            <ToolsBarItem
                index={2}
                title="Frames"
                onClick={onItemClick}
                selected={selectedIndex === 2}
                isAboveTheSelected={2 + 1 === selectedIndex}
                isBelowTheSelected={2 - 1 === selectedIndex}
                isDisabledTab={props.isDisabledTabs || isDisabledRightTabBtn || isAccountTier1}
                titleForBtn={isAccountTier1 ? "Upgrade your account" : ""}
            />
            <ToolsBarItem
                index={3}
                title="Promotions & Items"
                onClick={onItemClick}
                selected={selectedIndex === 3}
                isAboveTheSelected={3 + 1 === selectedIndex}
                isBelowTheSelected={3 - 1 === selectedIndex}
                isDisabledTab={props.isDisabledTabs || isDisabledRightTabBtn || isAccountTier1}
                titleForBtn={isAccountTier1 ? "Upgrade your account" : ""}
            />
            {/*<ToolsBarItem*/}
            {/*    index={4}*/}
            {/*    title="Items"*/}
            {/*    onClick={onItemClick}*/}
            {/*    selected={selectedIndex === 4}*/}
            {/*    isAboveTheSelected={4 + 1 === selectedIndex}*/}
            {/*    isBelowTheSelected={4 - 1 === selectedIndex}*/}
            {/*    isDisabledTab={props.isDisabledTabs}*/}
            {/*/>*/}
        </div>
    )
}